import { FormHelperText, Radio, RadioGroup } from '@mui/joy';

import { useCurrentTier } from '@/hooks/useCurrentTier';
import {
  InstanceFlags,
  useInstanceFlagOrDefault,
} from '@/hooks/useInstanceFlag';
import { TraceTTLTier } from '@/types/schema';

import { PAYMENT_PLAN_PRICING_MAP } from '../utils/constants';

type Props = {
  ttl: TraceTTLTier | null;
  setTTL: (ttl: TraceTTLTier) => void;
};

const CondensedDataRetentionSetting = ({ ttl, setTTL }: Props) => {
  const { tier } = useCurrentTier();

  const { shortLivedPricePerTrace, longLivedPricePerTrace } =
    tier && PAYMENT_PLAN_PRICING_MAP[tier]
      ? PAYMENT_PLAN_PRICING_MAP[tier]
      : PAYMENT_PLAN_PRICING_MAP['plus'];

  const ttlDurations = useInstanceFlagOrDefault(
    InstanceFlags.trace_tier_duration_days
  );

  return (
    <div className="flex flex-col items-stretch gap-2">
      <RadioGroup
        value={ttl}
        onChange={(e) => {
          setTTL(e.target.value as TraceTTLTier);
        }}
        name="radio-buttons-group"
      >
        <Radio
          value={TraceTTLTier.shortlived}
          label={`Base - Traces are automatically deleted after ${
            ttlDurations[TraceTTLTier.shortlived]
          } days.`}
          slotProps={{
            input: {
              'aria-describedby': 'default-helper-text',
            },
            label: { className: 'text-sm font-semibold text-ls-black' },
          }}
        />
        {shortLivedPricePerTrace > 0 && (
          <FormHelperText
            id="default-helper-text"
            className="text-sm font-normal text-tertiary"
          >
            Calculated at ${shortLivedPricePerTrace.toFixed(4)} per short-lived
            trace
          </FormHelperText>
        )}

        <Radio
          value={TraceTTLTier.longlived}
          label={`Extended - All traces are retained for ${
            ttlDurations[TraceTTLTier.longlived]
          } days.`}
          slotProps={{
            input: { 'aria-describedby': 'extended-helper-text' },
            label: { className: 'text-sm font-semibold text-ls-black' },
          }}
        />
        {longLivedPricePerTrace + shortLivedPricePerTrace > 0 && (
          <FormHelperText
            id="extended-helper-text"
            className="text-sm font-normal text-tertiary"
          >
            ${(longLivedPricePerTrace + shortLivedPricePerTrace).toFixed(4)}{' '}
            each for all traces
          </FormHelperText>
        )}
      </RadioGroup>
    </div>
  );
};

export { CondensedDataRetentionSetting };
